import { render } from "./ServicesDatatableTRServiceCategory.vue?vue&type=template&id=f07d3fc0&scoped=true"
import script from "./ServicesDatatableTRServiceCategory.vue?vue&type=script&lang=js"
export * from "./ServicesDatatableTRServiceCategory.vue?vue&type=script&lang=js"

import "./ServicesDatatableTRServiceCategory.vue?vue&type=style&index=0&id=f07d3fc0&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f07d3fc0"]])

export default __exports__